export default {
  getIsLoading: state => state.isLoading,
  getLanguage: state => state.language,
  getLanguages: state => state.languages,
}
